global.constants = {
    const_url: 'https://www.gaoyuanzi.com',
    const_localstorage_id: 'gaoyuanzi-cti',
    const_app_not_found: '页面未找到',
    const_app_component_width: 395,
    const_tools: '工具',
    const_main: '首页',
    const_home: '我的',
    const_home_url: 'https://www.gaoyuanzi.com',
    const_img_url: 'https://www.gaoyuanzi.com',
    const_app_url: 'https://www.gaoyuanzi.com/api/v1/app',
    const_user_url: 'https://www.gaoyuanzi.com/api/v1/user',
    const_agriculture_url : 'https://www.gaoyuanzi.com/api/v1/agriculture',
    const_amap_key: 'b7c2e11533f64cb29853b0a1f439aba6',
    const_toast_timeout: 2000,
    const_register: '注册',
    const_submit: '提交',
    const_login: '登录',
    const_save: '保存',
    const_modify: '修改',
    const_logout: '退出',
    const_cancel: '取消',
    const_username: '用户名',
    const_password: '密码',
    const_alias: '昵称',
    const_email: 'Email',
    const_version: '版本',
    const_describe: '描述',
    const_tag: '标签',
    const_ok: '确定',
    const_userid: '用户ID',
    const_context: '内容',
    const_upload: '上传',
    const_download: '下载',
    const_delete: '删除',
    const_rename: '重命名',
    const_detail: '详细信息',
    const_execute: '执行',
    const_config: '配置',
    const_title: '标题',
    const_label: '标签',
    const_on: '开',
    const_off: '关',
    const_online: '在线',
    const_offline: '未登录',
    const_state_version: '0.1',
    const_default_username: 'tmp',
    oonst_default_username: 'tmp',
    const_default_accesstoken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjMzMDY0NzQzOTYsImlzcyI6ImF6eiJ9.6AfjNv08aXIYNeR9D4P66fx1HYErDDmD4icPR1bCPgY',
    const_tools_header_name: '工具',
    const_tools_footer_end_name: '结束',
    const_tools_panel_filesize_name: '大小',
    const_tools_panel_access_number_name: '次访问',
    const_tools_panel_access_name: '地址',
    const_home_statement_name: '软件许可及服务协议',
    const_home_qrcode_name: '主页二维码',
    const_home_register_my_username: '用户名',
    const_home_register_my_password: '密码',
    const_home_register_my_alias: '昵称',
    const_home_register_my_email: 'Email',
    const_home_register_tool_name: '注册工具',
    const_home_register_tool_title: '名称',
    const_home_register_tool_version: "版本号",
    const_home_register_tool_url: "URL",
    const_home_register_tool_des: "功能描述",
    const_home_register_tool_logo: "Logo",
    const_home_register_tool_tag: "标签",
    const_home_register_tool_tag_safe: "安全",
    const_home_register_tool_tag_video: "视频",
    const_home_register_tool_tag_data: "数据",
    const_home_register_tool_tag_audio: "音频",
    const_home_register_tool_tag_image: "图片",
    const_home_register_tool_submit: "提交",
    const_home_register_tool_title_des: '按照格式填写各项内容，然后提交可完成工具注册',
    const_home_username: '用户名',
    const_home_register: '注册',
    const_home_register_title: '按照格式填写各项内容，然后提交可完成注册',
    const_home_myinfo: '个人信息',
    const_app_qrcode_decode_title: '解码QrCode二维码',
    const_app_qrcode_title: '生成QrCode二维码',
    const_app_upload_tip: '上传小于30个文件，且单个文件不超过200M',
    const_app_click_upload: '点击上传',
    const_app_file_list: '个人文件',
    const_app_chart_bar: '柱状图',
    const_app_chart_line: '折线图',
    const_app_chart_pie: '饼图',
    const_app_chart_radar: '雷达图',
    const_app_chart_horizontalbar: '垂直柱状图',
    const_app_chart_doughnut: 'Doughnut图',
    const_app_chart_bubble: 'Bubble图',
    const_app_chart_polar: 'Polar图',
    const_app_chart_scatter: 'Scatter图',
    const_app_chart_err_title: '错误数据字段或行:',
    const_app_chart_leastsq: '最小二乘法线性回归',
    const_app_chart_input_title: '标题',
    const_app_chart_input_label: '标签',
    const_app_chart_input_region: '数据区域',
    const_app_chart_inputdata: '请输入数据',
    const_app_chart_express: '表达式',
    const_app_chart_fitline: '线性拟合',
    const_app_chart_dialog_title: '参数配置',
    const_app_chart_dialog_title_position: '标题位置',
    const_app_chart_dialog_label_position: '标签位置',
    const_app_chart_dialog_label_title_width: '80',
    const_app_chart_dialog_label_enable: '标签显示',
    const_app_chart_dialog_title_enable: '标题显示',
    const_app_chart_dialog_xaxis: 'X轴',
    const_app_chart_dialog_xaxis_enable: 'X轴显示',
    const_app_chart_dialog_yaxis: 'Y轴',
    const_app_chart_dialog_yaxis_enable: 'Y轴显示',
    const_app_chart_color: '#20a0ff',
    const_app_chart_window_height: '70',
    const_app_chart_window_width: '100',
    const_app_chart_dialog_widow_height_title: '窗口高',
    const_app_chart_dialog_widow_width_title: '窗口宽',
    const_app_chart_dialog_console_express_enable: '公式显示',
    const_app_chart_dialog_console_real_value_enable: '预测显示',
    const_app_chart_dialog_console_real_value: '实际值',
    const_app_chart_leastsq_real_value: '实际值',
    const_app_chart_leastsq_predict_value: '预测值',
    const_app_chart_leastsq_rate: '比值[(预测-实际)/预测*100]',
    const_app_chart_leastsq_real_value_seq: '实际序列',
    const_app_chart_leastsq_sub_value_seq: '差值[预测-实际]',
    const_app_chart_fitline_loss: '误差',
    const_app_chart_fitline_optimized_time: '优化次数',
    const_app_chart_fitline_loss_value: '损失小于',
    const_app_chart_corr_coefficient: '相关系数',
    const_adm_en_home: 'Home',
    const_adm_field_cn2en: '字段标准化',
    const_adm_edw: '数据仓库',
    const_adm_audio: '有声小说',
    const_adm_tools: '工具管理',
    const_adm_script_package: '脚本封装',
    const_app_audio_catalog: '有声小说分类',
    const_app_pig_his: '生猪价格',
    const_app_price_pig_his: '价格历史同期',
    const_app_price_type: '类型',
    const_app_setting: '设置',
    const_app_province: '省地域',
    const_app_grain_size: '粒度',
    const_day: '天',
    const_month: '月',
    const_app_period: '时间区间',
    const_app_map_marker: '地图标注',
    const_app_map_address: '地址',
    const_app_map_marker_icon: '图标',
    const_app_txt2audio: '文本转语音',
    const_app_txt2audio_voice: '语音',
    const_app_txt2audio_rate: '语速',
    const_app_txt2audio_volume: '音量',
    const_app_txt2audio_voices: '语调',
    const_app_txt2audio_txt: '文本',
    const_app_face_draw_title: '图片人物化妆',
    const_app_face_url_prefix: 'http://106.75.249.244:9000/tmp/img-',
    const_app_chirstmas_hat: '圣诞帽',
    const_app_stat_accesslog: '访问统计数据',
    const_app_video_edit: '视频编辑',
    const_app_image_edit: '图片编辑',
    //main
     const_color_icon:'#64b5f6',
    //const_color_icon:'#e60000',
    const_app_home_beian: '沪公网安备31011502018687',
    const_app_home_icp: '沪ICP备2021004294',
    const_app_home_register_tool: '注册工具',
    const_question: '问题和反馈',
    const_app_home_home: '应用',
    const_color_bg: '#FFFFFF',
    const_default_header_height: 60,  
    //登录
    const_secret_key: 'aya1234567890zxy',
    const_app_home_user_username: '用户名',
    const_app_home_user_passwd: '密  码',
    const_app_textfiled_width: 320,
    const_app_input_width: 320,
    const_app_home_user_login: '登录',
    //注册
    const_app_user_register: '用户注册',
    const_app_user_register_username: '用户名',
    const_app_user_register_password: '密  码',
    const_app_user_register_alias: '昵称',
    const_app_user_register_mail: '邮箱',
    const_app_button_width: 150,
    //user
    const_app_home_user_header: '用户信息',
    const_app_home_user_alias: '昵称',
    const_app_home_user_userid: '用户ID',
    const_app_home_user_email: '邮箱',
    const_app_home_user_logout: '注销',
    //poetry
    const_app_poetry: '中华古文',
    //pdf
    const_app_pdf_url: 'URL',
    const_app_pdf_title: '标题',
    const_app_pdf_tag: '分类',
    const_app_pdf_new: '新建',
    const_app_pdf_catalog: '目录',
    const_app_pdf_mgr: '分类管理',
    const_app_pdf_share: '分享',

    //
    const_app_price_agriculture:'农产品价格',

};
